















import { defineComponent } from '@nuxtjs/composition-api';
import AppImage from '~/components/partials/App/AppImage.vue';

const DEFAULT_IMAGE_PC = require('~/assets/svg/article-thumbnail-no-img-pc.svg');
const DEFAULT_IMAGE_SP = require('~/assets/svg/article-thumbnail-no-img-sp.svg');

export default defineComponent({
  components: {
    AppImage,
  },
  props: {
    thumbnailImageSp: {
      type: String,
      default: null,
    },
    thumbnailImagePc: {
      type: String,
      default: null,
    },
    mainImageSp: {
      type: String,
      default: null,
    },
    mainImagePc: {
      type: String,
      default: null,
    },
    alt: {
      type: String,
      default: null,
    },
    // 生産者がパーツがトップと生産者一覧で使っているが生産者一覧画面の方が画像比率の問題で両サイドが少し削られてしまっているため暫定で生産者一覧かを見て対応
    isProducerList: {
      type: Boolean,
      default: null,
    },
  },
  setup() {
    return {
      DEFAULT_IMAGE_SP,
      DEFAULT_IMAGE_PC,
    };
  },
});
